import { createReducer, on } from '@ngrx/store';
import {
  InvoiceDetails,
  InvoiceInfoClosed,
  InvoiceShowAttributes,
  InvoiceShowCoupons,
  LoadInvoiceDisplayedColumns,
} from '../actions/invoice-info.actions';

export interface InvoiceInfoState {
  details: boolean;
  showCoupons: boolean;
  showAttributes: boolean;
  displayedColumns: { [label: string]: string };
  gridData: any;
  stringAttributesData: any;
  integerAttributesData: any;
  booleanAttributesData: any;
  dateAttributesData: any;
}

const initialState: InvoiceInfoState = {
  details: false,
  showCoupons: false,
  showAttributes: false,
  displayedColumns: {},
  gridData: '',
  stringAttributesData: '',
  integerAttributesData: '',
  booleanAttributesData: '',
  dateAttributesData: '',
};

export const InvoiceInfoReducer = createReducer(
  initialState,
  on(InvoiceDetails, (state, { gridData }) => ({
    ...state,
    gridData: gridData.invoiceLineList,
    details: true,
  })),
  on(InvoiceShowCoupons, (state, { gridData }) => ({
    ...state,
    gridData: gridData.couponList,
    showCoupons: true,
  })),
  on(InvoiceShowAttributes, (state, { gridData }) => ({
    ...state,
    stringAttributesData: Object.keys(gridData.attributes.stringAttributes).length
      ? Object.entries(gridData.attributes.stringAttributes)
      : [],
    integerAttributesData: Object.keys(gridData.attributes.integerAttributes).length
      ? Object.entries(gridData.attributes.integerAttributes)
      : [],
    booleanAttributesData: Object.keys(gridData.attributes.booleanAttributes).length
      ? Object.entries(gridData.attributes.booleanAttributes)
      : [],
    dateAttributesData: Object.keys(gridData.attributes.dateAttributes).length
      ? Object.entries(gridData.attributes.dateAttributes)
      : [],
    showAttributes: true,
  })),
  on(LoadInvoiceDisplayedColumns, (state, { displayedColumns }) => ({
    ...state,
    displayedColumns,
  })),
  on(InvoiceInfoClosed, () => initialState),
);
